import { useTranslation } from 'react-i18next';

export function LoadingScreen() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-mesh p-4">
      <div className="relative w-16 h-16 animate-fade-in">
        <svg className="w-16 h-16" viewBox="0 0 50 50" style={{ animation: 'spinner-rotate 1.4s linear infinite' }}>
          <circle
            cx="25" cy="25" r="20"
            fill="none"
            stroke="url(#brand-gradient)"
            strokeWidth="3.5"
            strokeLinecap="round"
            style={{ animation: 'spinner-dash 1.4s ease-in-out infinite' }}
          />
          <defs>
            <linearGradient id="brand-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#500B4D" />
              <stop offset="100%" stopColor="#DC2A4A" />
            </linearGradient>
          </defs>
        </svg>
      </div>

      <p className="mt-6 text-sm text-muted-foreground animate-pulse font-medium tracking-wide">
        {t('common.loading')}
      </p>
    </div>
  );
}
